import React from 'react'
import { Link } from "gatsby";
import { render } from "storyblok-rich-text-react-renderer"
import { sbEditable } from "@storyblok/storyblok-editable";


const NewsList = ({ blok }) => {
    console.log(blok)
    const newsList = blok.news_post

    newsList.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.Date) - new Date(a.Date);
    });


    const EventList = blok.news_post.map((resource, i) => {
        const eventDate = new Date(resource.Date)
        // console.log(eventDate)
        const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };

        if (resource.Published != "true") {
            // return <div className="card mb-6" key={i} style={{ backgroundColor: "#FFEBD0" }}>
            //     <div className="card-content">
            //         <div className="column is-11">
            //             <div className="content">
            return <div className="block">
                <p className="has-text-weight-bold is-size-3 mb-0">{resource.Headline}</p>
                <p className="has-text-weight-bold is-size-5 pb-4">{eventDate.toDateString()}</p>
                <p className="mb-4">
                    {render(resource.description)}
                </p>
                <hr></hr>
            </div>
            //                 {/* <a href={resource.link.url}>Link</a> */}
            //             </div>
            //         </div>
            //     </div>
            // </div>
        }
    }
    )

    return (
        <div {...sbEditable(blok)}>
            <div className="section" style={{ backgroundColor: "#FFF" }}>
                <div className="container">
                    <h1
                        className="is-size-3 label has-text-centered"
                    >
                        {blok.title}
                    </h1>
                    {EventList}
                </div>

            </div>
        </div>
    )
}

export default NewsList;